const about = [
  {
    "key": "a01",
    "title": "About Me",
    "skills": "Designer",
    "content": [
      {
        "component": "Title",
        "content": "About Me"
      },
      {
        "component": "Subheading",
        "design": "centered",
        "content": "Mission Statement"
      },
      {
        "component": "Body",
        "design": "centered",
        "content": "<em>I am a passionate son of the Most High who values complete surrender of self to the praise and glory of God. I seek to demonstrate my unwavering commitment and dedication to impactful missions and teams that are in need of the skills of problem solving, empathy, and craftsmanship I have been so blessed to obtain.</em>"
      },
      {
        "component": "Combination",
        "design": "image-one-third",
        "source": "about/nick-portrait-round_500.png",
        "title": "Rely on me to deliver.",
        "content": "I am a loyal, hard-working creative with 9 years of professional design experience! I've mastered dozens of software tools and creative techniques. I'm also goal-oriented with the ability to self-prioritize. I have an exceptional attention to detail and am willing to put in the hard work to accomplish complex tasks. You won't find a more responsible, efficient, and capable creative out there ready to join your team."
      },
      {
        "component": "Subheading",
        "content": "More About Me",
        "design": "centered"
      },
      {
        "component": "Body",
        "content": "I am married and have one child right now. Faith and family are my top priorities. We love to serve in a church setting with children's ministries like AWANA, and are passionate about promoting the beautiful simplicity of the gospel of Jesus Christ. I also enjoy serving on worship teams wherever opportunities and needs arise. I play piano, bass guitar, drums, and sing. Most evenings you'd find Ruth and me playing board games by ourselves or with friends in our home. Our current favorites are Catan, Bohnanza, Quirkle, and two-player card games. We also enjoy <em>The Great British Baking Show</em> and <em>Til Debt Do Us Part</em>. "
      },
      {
        "component": "Body",
        "content": "A personal hobby of mine is making music. I started a Youtube Channel a few years back for my electronic music that's been growing. Recently, I had a video exceed 20k views, which is really exciting! It's a nice creative outlet for me that is different from the normal design work."
      },
      {
        "component": "YoutubeEmbed",
        "embedId": "MTRTjkJM-A0"
      },
      {
        "component": "Combination",
        "design": "image-one-third",
        "source": "about/photography_behind-the-scenes.jpg",
        "alt": "Nicholas showing a family with kids photos on the back of his camera",
        "content": "I also love photography! Ruth and I started making it somewhat of a side business. I love working with families and couples to help them laugh, relax, and smile. Seeing the beauty of their moment come to life is incredible."
      },
      {
        "component": "Body",
        "content": "I've been editing photos since I was in middle school, and so I've loved the opportunity to keep up that skill through client photography. I've also applied my photo editing skills in the workplace. I've shot product photography for the companies I've worked at as well as taken company headshots and held photoshoots for marketing campaigns."
      }
    ]
  }
]
export default about;